// SPDX-FileCopyrightText: 2025 LiveKit, Inc.
//
// SPDX-License-Identifier: Apache-2.0
import * as eot from './eot/index.js';
import * as llm from './llm.js';
import * as stt from './stt.js';
import * as tts from './tts.js';

export { eot };
export {
  TurnDetector,
  TurnDetectorStreamImpl,
  LOCAL_LANGUAGES,
  CloudTransport,
  LocalTransport,
  ThresholdOptions,
  type TurnDetectorOptions,
  type CloudTransportOptions,
  type ThresholdOverride,
  type TurnDetectorModel,
  type TurnDetectorVersion,
} from './eot/index.js';

export { VAD, type VADOptions, type VADModels } from './vad.js';

export {
  AvatarSession,
  parseAvatarModel,
  type AvatarModel,
  type AvatarSessionOptions,
  type AvatarSessionStartOptions,
  type LemonSliceOptions,
} from './avatar.js';

export {
  LLM,
  LLMStream,
  type ChatCompletionOptions,
  type GatewayOptions,
  type InferenceClass,
  type InferenceLLMOptions,
  type LLMModels,
  type XAIModels,
  type ZAIModels,
} from './llm.js';

export {
  normalizeSTTFallback,
  parseSTTModelString,
  STT,
  type DeepgramFluxModels,
  type DeepgramFluxOptions,
  type InworldSTTModels,
  type InworldSTTOptions,
  type STTFallbackModel,
  type STTFallbackModelType,
  type STTLanguages,
  type STTModels,
  type ModelWithLanguage as STTModelString,
  type STTOptions,
  type XaiSTTModels,
  type XaiOptions as XaiSTTOptions,
} from './stt.js';

export {
  normalizeTTSFallback,
  parseTTSModelString,
  TTS,
  type TTSFallbackModel,
  type TTSFallbackModelType,
  type TTSModels,
  type ModelWithVoice as TTSModelString,
  type TTSOptions,
  type XaiTTSModels,
  type XaiTTSOptions,
} from './tts.js';

export { llm, stt, tts };
